import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  title: {
    marginLeft: 24
  },
  counter: {
    marginLeft: 16
  }
})
